import React, {useState, useEffect} from 'react';
import './MainPage.css';
import Welcome from '../../components/welcome';
import Sidebar from '../../components/sidebar';

import Welcome_new from '../../components/welcome_for_user';
import Sidebar_new from '../../components/sidebar_for_user';
import UserPool from '../../components/autorize/UserPool';
import {Helmet} from "react-helmet";

function MainPage() {
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [user, setUser]=useState("");
    const token = localStorage.getItem("token");
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const cognitoUser = UserPool.getCurrentUser();
            setUser(cognitoUser.username)
        } 
    }, []);
    return (
        <div className="main-page">
            {/* {
                langmenu=="de"?
                <Helmet>
                    <title>Bind Genius — Hyperpersonalisierte Kundenkommunikation mit Hilfe von Prädiktiver und Generativer KI</title>
                    <meta name="description" content="Verbesserung des Kundenerlebnisses mit Bind Genius. Historische und prädiktive Analysen sowie generative KI zur Erstellung von personalisierten Inhalten, um Kunden effektiv zu binden, den Umsatz zu steigern und den Customer Lifetime Value zu erhöhen." />
                </Helmet>
                :
                <Helmet>
                    <title>Bind Genius — Hyper-personalized Customer Communication Using Predictive and Generative AI</title>
                    <meta name="description" content="Enhancing customer experience with Bind Genius. Historical and predictive analytics, along with generative AI, to create personalized content aimed at effectively retaining customers, increasing sales, and boosting Customer Lifetime Value." />
                </Helmet>
            } */}
            {
            
                user=="admin"|| user=="gewgur"?
                <>
                    <Sidebar_new/>
                    <Welcome_new/>
                </>
                :
                <>
                    <Sidebar/>
                    <Welcome/>
                </>
            }
        </div>
    );
}

export default MainPage;

